import { BaseService } from '@flint/framework';

export default class EditSubscription extends BaseService {
  constructor() {
    super("EDITING_SUBSCRIPTION_DATA", 'EditSubscriptionStore', true);
  }

  handleEvent(eventName, subscription) {
    return this.getClient('vetService').put('/admin-api/subscriptions/', subscription);
  }
}